import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const PaypalOrderCaption = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", {
        className: "pay-pal-order-caption"
    }, getLabel('checkout.express.complete.action.orderWith'), /*#__PURE__*/ React.createElement(Icon, {
        name: "paypal-checkout-button-icon",
        viewBox: "0 0 77 22",
        width: 77,
        height: 22
    }));
};
const PaypalOrderButton = ({ onClick , isLoading =false , isDisabled =false  })=>{
    const caption = /*#__PURE__*/ React.createElement(PaypalOrderCaption, null);
    const breakPoint = MediaQuery.useBreakpoint();
    return /*#__PURE__*/ React.createElement(Button, {
        isLoading: isLoading,
        disabled: isDisabled,
        size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
        className: "cart-navigation__button pay-pal-order",
        "data-t": "paypal-order-action",
        caption: caption,
        onClick: onClick
    });
};

export { PaypalOrderButton };
//# sourceMappingURL=PaypalOrderButton.js.map
